<template>
  <Card>
    <LocalDataTable :columns="columns" :ajax-link="ajaxLink"></LocalDataTable>
  </Card>
</template>

<script>
import {mapActions} from "vuex";
import Card from "@/components/forms/Card";
import LocalDataTable from "@/components/LocalDataTable";

export default {
name: "RequestSpecialAccountList",
  components: {LocalDataTable, Card},
  data()
  {
    return{
      columns : [
        {title : 'تاریخ ثبت'},
        {title : 'کابر'},
        {title : 'وضعیت'},
        {title : '<i class="far fa-cogs"></i>'},
      ],
      ajaxLink : 'admin/RequestSpecialAccount/List'
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('درخواست های کاربر ویژه');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>